import CookieReader from 'cookies-js';

export class CookieUtils {

    static get COOKIE_CONFIGS () {

        return {
            cookieBannerConfigs: {
                cookieName: 'cookieBanner',
                valueToStoreAndCheck: 'closed',
                expirationTime: Infinity
            },
            cookieMagicStickConfigs: {
                cookieName: 'magicStick',
                valueToStoreAndCheck: 'closed',
                expirationTime: Infinity
            }
        };
    }

    static isCookieSet (cookieName, cookieValueToCheck) {

        return (CookieReader(cookieName) && CookieReader.get(cookieName) === cookieValueToCheck);
    }

    static setCookie (cookieName, cookieValueToStore, expirationTime) {

        if (expirationTime) {

            CookieReader.set(cookieName, cookieValueToStore, { expires: expirationTime });
        } else {

            CookieReader.set(cookieName, cookieValueToStore);
        }
    }
}


// WEBPACK FOOTER //
// ./shared/utils/CookieUtils.js